import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // ======================
  // AUTH STATE
  // ======================
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  const [profile, setProfile] = useState(null);

  const token = localStorage.getItem('token');

  // ======================
  // ROLE PREFIX
  // ======================
  const rolePrefix =
    user?.role === 1 || user?.role === 2 ? 'admin' : 'intervenant';

  // ======================
  // LOGIN
  // ======================
  const login = async (email, password) => {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/login`,
      {
        email,
        password,
      }
    );

    const data = res.data;

    const baseUser = {
      id: data.id,
      name: data.name,
      role: data.role,
      token: data.token,
    };

    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(baseUser));

    setUser(baseUser);

    return baseUser;
  };

  // ======================
  // FETCH PROFILE
  // ======================
  const fetchProfile = useCallback(async () => {
    try {
      if (!token || !user) return;

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${rolePrefix}/user/profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setProfile(res.data.profile);
    } catch (err) {
      console.error('Profile fetch error:', err);
    }
  }, [token, user?.id, rolePrefix]);

  // ======================
  // AUTO LOAD PROFILE
  // ======================
  useEffect(() => {
    if (token && user?.id) {
      fetchProfile();
    }
  }, [token, user?.id, fetchProfile]);

  // ======================
  // LOGOUT
  // ======================
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setProfile(null);
  };

  // ======================
  // PROVIDER VALUE
  // ======================
  return (
    <AuthContext.Provider
      value={{
        user,
        profile,
        setUser,
        setProfile,
        login,
        logout,
        fetchProfile,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// ======================
// HOOK
// ======================
export const useAuth = () => useContext(AuthContext);